import { render } from "./student_verifyDialog.vue?vue&type=template&id=2df8120d"
import script from "./student_verifyDialog.vue?vue&type=script&lang=js"
export * from "./student_verifyDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__